import React from 'react'
import {Dropdown, Menu} from "antd";
import {AVAILABLE_LANGUAGES, CHANGE_LANG, izTrue} from "../constants";
import i18n from "i18next";
import $ from "jquery";
import {bindActionCreators} from "redux";
import {UserAction} from "../actions/UserAction";
import {CommonAction} from "../actions/CommonAction";
import {connect} from "react-redux";
import CommonService from "../services/common.service";
import authService from '../services/auth.service';
import authHeader from '../services/auth-header';

class Language extends React.Component {

    langList() {
        return <Menu>
            {AVAILABLE_LANGUAGES.map((lang, index) => (
                <Menu.Item key={index} onClick={() => this.changeLanguage(lang)}>
                  <span className="lang-option">
                    <img
                        alt=""
                        width={24}
                        className="language-flag"
                        src={this.getFlagImage(lang)}
                    />
                      {i18n.t('lang_' + lang)}
                  </span>
                </Menu.Item>
            ))}
        </Menu>;
    }

    changeLanguage(lang) {

        const {skipCommon, customChangeLanguage, customIndex} = this.props;

        if (izTrue(skipCommon)) {
            customChangeLanguage(lang, customIndex);
        } else {
            $('.navbar-collapse-one').collapse('hide')

            if (lang && this.props.common.lang !== lang) {
                CommonService.saveLang(lang)
                i18n.changeLanguage(lang)
                this.props.commonAction(CHANGE_LANG, lang)

                if (authService.getCurrentUser()) {
                    authService.updateUserLang(lang, authHeader)
                }

                if (window.location
                    && window.location.pathname
                    && (window.location.pathname.includes("checkout-two"))) {
                    window.location.reload()
                }
            }
        }
    }

    getFlagImage(lang) {
        return require('../assets/img/flags/' + lang + '.svg');
    }

    render() {

        const {skipCommon, customLang, hoverDisabled} = this.props;
        let lang = this.props.common.lang;
        if (izTrue(skipCommon)) {
            lang = customLang;
        }

        return (
            <>
                <Dropdown
                    trigger={["click", izTrue(hoverDisabled) ? "" : "hover"]}
                    overlay={this.langList()}
                    placement="bottomCenter">
                    <a className="lang-dropdown">
                        <img alt=""
                             width={24}
                             className="language-flag"
                             src={this.getFlagImage(lang)}
                        />
                    </a>
                </Dropdown>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Language)